export default "__VITE_ASSET__zhph$FPB__"